<div class="dialog">
  <header mat-dialog-title class="header">
    <div class="header__text">
      <h2 class="header__title">{{ data.kbName }}</h2>
      <div class="header__subtitle">
        @if (data.managedBy) {
          <span class="header__managed">
            <mat-icon class="header__managed-icon">share</mat-icon>
            {{ 'KNOWLEDGE_SHARING.SOURCES.MANAGED_BY' | translate: { partner: data.managedBy } }}
          </span>
        }
        @if (data.kbDescription) {
          <span>{{ data.kbDescription }}</span>
        }
      </div>
    </div>
  </header>

  <mat-dialog-content class="content">
    @if (readOnly) {
      <p class="lede">
        {{ 'KNOWLEDGE_SHARING.SOURCES.READONLY_LEDE' | translate: { partner: data.managedBy } }}
      </p>
      <ul class="sources__list sources__list--readonly">
        @for (ks of data.currentSources; track ks.id) {
          <li class="sources__row">
            <div class="sources__label">
              <mat-icon class="sources__icon">{{ iconFor(ks.kind) }}</mat-icon>
              <div class="sources__text">
                <div class="sources__name">{{ ks.name }}</div>
                @if (ks.subtitle) {
                  <div class="sources__sub">{{ ks.subtitle }}</div>
                }
              </div>
            </div>
          </li>
        } @empty {
          <li class="sources__empty">{{ 'KNOWLEDGE_SHARING.SOURCES.EMPTY_READONLY' | translate }}</li>
        }
      </ul>
    } @else {
      <p class="lede">
        {{ 'KNOWLEDGE_SHARING.SOURCES.EDIT_LEDE' | translate }}
      </p>

      @if (data.availableSources.length > 4) {
        <glxy-form-field class="sources__search" suffixIcon="search" bottomSpacing="none" [showLabel]="false">
          <glxy-label>{{ 'COMMON.SEARCH' | translate }}</glxy-label>
          <input
            matInput
            [ngModel]="search()"
            (ngModelChange)="search.set($event)"
            [placeholder]="'KNOWLEDGE_SHARING.SOURCES.SEARCH_PLACEHOLDER' | translate"
          />
        </glxy-form-field>
      }

      <ul class="sources__list">
        @for (ks of filteredSources(); track ks.id) {
          <li class="sources__row">
            <mat-checkbox
              color="primary"
              [checked]="isSelected(ks)"
              (change)="toggle(ks, $event.checked)"
            >
              <div class="sources__label">
                <mat-icon class="sources__icon">{{ iconFor(ks.kind) }}</mat-icon>
                <div class="sources__text">
                  <div class="sources__name">{{ ks.name }}</div>
                  @if (ks.subtitle) {
                    <div class="sources__sub">{{ ks.subtitle }}</div>
                  }
                </div>
              </div>
            </mat-checkbox>
          </li>
        } @empty {
          <li class="sources__empty">{{ 'KNOWLEDGE_SHARING.SOURCES.NO_MATCHING_SOURCES' | translate }}</li>
        }
      </ul>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="actions">
    @if (!readOnly) {
      <span class="actions__count">
        {{
          (selectedCount() === 1
            ? 'KNOWLEDGE_SHARING.SOURCES.COUNT_ONE'
            : 'KNOWLEDGE_SHARING.SOURCES.COUNT_OTHER'
          ) | translate: { count: selectedCount() }
        }}
      </span>
    }
    <button mat-button [disabled]="submitting()" (click)="cancel()">
      {{ (readOnly ? 'COMMON.CLOSE' : 'COMMON.CANCEL') | translate }}
    </button>
    @if (!readOnly) {
      <button mat-flat-button color="primary" [disabled]="!dirty() || submitting()" (click)="apply()">
        {{ 'KNOWLEDGE_SHARING.SOURCES.APPLY' | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
